import {
  formatDistanceToNow,
  parseISO,
  sub,
  isAfter,
  startOfDay,
  getWeekOfMonth,
  getDate,
  toDate,
  getMonth,
  setDate,
  setMonth,
} from 'date-fns';
import { format } from 'date-fns-tz';
import { enUS } from 'date-fns/locale';

const locales = { enUS }; // Add more as necessary

// Setting locale example:
// window.__localeId__ = 'en'

const formatTimeDistance = (date) =>
  date > new Date() ? 'now' : formatDistanceToNow(date, { addSuffix: true });

const formatWithLocale = (date, formatStr) => {
  return format(date, formatStr, { locale: locales[window.__localeId__] });
};

export const formatDate = (date, isLongDate = false, separator = '-') => {
  const formatString = isLongDate ? 'PPPP' : 'P';
  return formatWithLocale(date, `${formatString} ${separator} kk:mm zzz`);
};

export const formatISODate = (dateString, isLongDate = false, separator = '-') => {
  const date = dateString ? parseISO(dateString) : null;
  if (date === null) {
    return null;
  }

  return formatDate(date, isLongDate, separator);
};

export const formatActivityTime = (dateString, exactTime = false) => {
  const date = dateString ? parseISO(dateString) : null;
  if (date === null) {
    return null;
  }

  return exactTime ? formatDate(date) : formatTimeDistance(date);
};

export const getDateInFilenameFormat = () => {
  return format(new Date(), 'yyyy-MM-dd');
};

export const getOffsetDate = (offset) => {
  switch (offset) {
    case '24-hrs':
      return sub(new Date(), { days: 1 });
    case '48-hrs':
      return sub(new Date(), { days: 2 });
    case '1-week':
      return startOfDay(sub(new Date(), { weeks: 1 }));
    case '2-weeks':
      return startOfDay(sub(new Date(), { weeks: 2 }));
    case '30-days':
      return startOfDay(sub(new Date(), { days: 30 }));
    default:
      // eslint-disable-next-line no-console
      console.warn('invalid date offset value');
      return new Date();
  }
};

export const dateIsAfter = (date, compareAgainst) => {
  const isoDate = parseISO(date);
  const isoCompareDate = parseISO(compareAgainst);
  return isAfter(isoDate, compareAgainst);
};

export const formatDateOnly = (date) => {
  return format(parseISO(date), 'yyyy-MM-dd');
};

export const formatTimeOnly = (date) => {
  return formatWithLocale(parseISO(date), 'kk:mm zzz');
};

export const formatWeekOfMonth = (date) => {
  return getWeekOfMonth(date);
};

export const getMonthAndDay = (date) => {
  return format(date, 'MMMM d');
};

/**
 * Helper function that converts date to string of the format '2nd Friday'
 * @param {date} date js date object
 */
export const getNthWeekdayOfMonth = (date) => {
  const dayOfMonth = getDate(date);
  const nthDay = Math.ceil(dayOfMonth / 7);
  const dayOfWeek = format(date, 'EEEE');
  let result = '';
  switch (nthDay) {
    case 1:
      result = `First ${dayOfWeek}`;
      break;
    case 2:
      result = `Second ${dayOfWeek}`;
      break;
    case 3:
      result = `Third ${dayOfWeek}`;
      break;
    case 4:
      result = `Fourth ${dayOfWeek}`;
      break;
    case 5:
      result = `Fifth ${dayOfWeek}`;
      break;
    default:
      result = '';
  }
  return result;
};

export const combineDateAndTime = (date, time) => {
  console.log(combineDateAndTime);
  console.log(date);
  console.log(time);
  // clone the time object
  let combinedDate = toDate(time);
  combinedDate = setDate(combinedDate, getDate(date));
  combinedDate = setMonth(combinedDate, getMonth(date));
  return combinedDate;
};
